import { API_URL_V3 } from 'constants/config';
import type { Country } from 'models/country';
import { fetchJson } from 'utils/fetchJson/fetchJson';

export const countries = {
  fetch: ({ locale = 'EN' }) => {
    const path = `${API_URL_V3}/countries?locale=${locale}`;

    return fetchJson<Country[]>(path);
  },
};
